import { all, put, takeEvery } from 'redux-saga/effects';
import { saveWriterDeviationSuccess } from '@wix/da-submit-shared/pkg/redux/actions';
import { refreshTable } from '../../actions/studio';

function* handleSaveWriterDeviationSuccess() {
  yield put(refreshTable({ preservePage: true }));
}

export default function* saga() {
  yield all([takeEvery(saveWriterDeviationSuccess, handleSaveWriterDeviationSuccess)]);
}
